import "@popperjs/core";
import "./bootstrap.min.js";

import { headerInit } from "./header/header.js";
import { industrySliderInit } from "./sliders/service-industry";
import testimonialsSliderInit from "./sliders/testimonials";

window.addEventListener("DOMContentLoaded", (event) => {
  console.log("DOM fully loaded and parsed");
  headerInit();
  industrySliderInit();
  testimonialsSliderInit();
  const navSearchContainer = document.getElementById("header-search-form");
  const navSearchIcon = document.getElementById("nav-search-icon");
  function toggleNavSearch() {
    console.log("hey nowowowow");
    navSearchContainer.classList.toggle("show");
  }

  navSearchIcon.addEventListener("click", toggleNavSearch);
});

/**
 *  Main Site JS
 */

// Store instances of these globally
var site;

// Main Site Class
var MySite = {
  //   $: null,

  // Main Init
  init: function (jQuery) {
    $ = jQuery;
    this.initPage();
    this.initCarousels();
    this.initForms();
    this.initProjects(); // Projects Isotope
    this.initServices(); // Services Isotope
    this.initContactLocations();
    this.smoothScroll();
    this.locationDropdown();

    return this;
  },

  initPage: function () {
    // Add the hamburger active classes for our menu toggle
    $("#topnav-collapse")
      .on("show.bs.collapse", function (e) {
        $("#mobile-menu-toggle").addClass("is-active");
      })
      .on("hide.bs.collapse", function (e) {
        $("#mobile-menu-toggle").removeClass("is-active");
      });
  },

  // Carousels
  initCarousels: function () {},

  // Location or Projects Map
  initProjectsMap: function () {
    var canvas = $("#map-canvas");
    if (canvas.length > 0) {
      // Storage for markers as array. We need this to be able to remove markers when filtering.
      var markers = [];
      var labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

      // Construct Map
      var mapOptions = {
        draggable: !("ontouchend" in document) || screen.width > 320,
        //draggable: true,
        scrollwheel: false,
        zoom: 12,
        maxZoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(
        document.getElementById("map-canvas"),
        mapOptions
      );

      // Custom Styles on the Map
      //var styles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#4a6e68"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"lightness":"12"},{"saturation":"-100"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#406d68"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"weight":"5.83"}]},{"featureType":"administrative.province","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#888686"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"saturation":"-100"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#cae4e0"}]},{"featureType":"landscape","elementType":"labels.text","stylers":[{"color":"#406d68"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"saturation":"-19"},{"lightness":"43"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"saturation":"-100"},{"color":"#ced4d3"},{"lightness":"10"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#819895"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.stroke","stylers":[{"lightness":"-19"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#d3e6e2"}]},{"featureType":"poi.park","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#888686"}]},{"featureType":"poi.park","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#fcfcfc"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#adc7c4"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"on"}]}];
      map.setOptions({ styles: mapstyles });

      // Cache the full set of locations and stores
      var locations = $("#iso-grid").find("> .item");

      // Draw the markers for the first time.
      drawMarkers();

      // Clear all markers
      function clearMarkers() {
        //Loop through all the markers and remove
        for (var i = 0; i < markers.length; i++) {
          markers[i].setMap(null);
        }
        markers = [];
      }

      // Drawing markers on the map
      function drawMarkers() {
        // Storage for the google bounds. We will fitBounds after markers are drawn.
        var bounds = new google.maps.LatLngBounds();

        // Draw store locations on the map
        locations.filter(":visible").each(function (i, el) {
          var loc = $(el);

          var icon = {
            // origin: new google.maps.Point(0, 0),
            // anchor: new google.maps.Point(0, 15),
            // size: new google.maps.Size(36.4, 51.2),
            scaledSize: new google.maps.Size(36, 51),
            url: "/wp-content/themes/challenger/assets/images/marker2.svg",
          };
          var marker = new google.maps.Marker({
            position: new google.maps.LatLng(loc.data("lat"), loc.data("lon")),
            map: map,
            icon: "/wp-content/themes/challenger/assets/images/m1.png",
            //label: labels[i % labels.length],
            //icon: icon,
            //icon: '/wp-content/themes/challenger/assets/images/marker.svg',
            info: infoWindowMarkup(loc.find(".txt")),
          });

          // var marker = new SVGMarker({
          // 	map: map,
          // 	position: new google.maps.LatLng( loc.data('lat') , loc.data('lon') ),
          // 	icon: {
          // 		anchor: new google.maps.Point(30, 30.26),
          // 		size: new google.maps.Size(60,30.26),
          // 		url: 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/134893/pin-red.svg'
          // 	},
          // 	info: infoWindowMarkup(loc.find('.txt'))
          // });

          // Add to global storage array.
          markers.push(marker);

          google.maps.event.addListener(marker, "click", function () {
            try {
              infowindow.close();
            } catch (err) {}
            infowindow = new google.maps.InfoWindow({
              content: marker.info,
            });
            infowindow.open(map, marker);
          });

          // Extend the map bounds
          bounds.extend(marker.position);
        });
        map.fitBounds(bounds);

        var markerCluster = new MarkerClusterer(map, markers, {
          imagePath: "/wp-content/themes/challenger/assets/images/m",
        });
      }

      function infoWindowMarkup(loc) {
        $locationHtml = '<div class="location-popup">' + loc.html() + "</div>";
        return $locationHtml;
      }

      // Grid Filters
      var $filters = $("#filters a");
      //$filters.removeClass('active');
      var _this = this;

      $filters.click(function (e) {
        e.preventDefault();
        $filters.removeClass("active");
        var a = $(e.currentTarget);
        var f = a.data("filterval");
        a.addClass("active");

        // Clear it all out
        locations.hide();
        clearMarkers();

        if (f == "") {
          locations.show();
        } else {
          // Filter and Redraw
          locations.filter(f).show();
        }

        drawMarkers();
        _this.doIsotope(f);
      });
    }
  },

  initProjects: function () {
    // Also, setup the map/grid toggles
    var $views = $("#map-grid-toggle > a");

    $("#map-grid-toggle").on("click", "a", function (event) {
      event.preventDefault();
      $views.removeClass("active");

      var a = $(event.currentTarget);
      var v = a.attr("href");

      if (v == "#view-both") {
        $("#projects-grid-wrapper").css({ height: "auto" });
        $("#map-canvas").css({ display: "block" });
      }
      if (v == "#projects-grid-wrapper") {
        $("#projects-grid-wrapper").css({ height: "auto" });
        $("#map-canvas").css({ display: "none" });
      }
      if (v == "#map-canvas") {
        $("#projects-grid-wrapper").css({ height: "0px" });
        $("#map-canvas").css({ display: "block" });
      }
      a.addClass("active");
    });

    // Kick off with the map by default
    // this.initIsotope();
    this.initProjectsMap();
  },

  initServices: function () {
    if ($("#iso-grid.services").length > 0) {
      // Grid Filters for services
      var $filters = $("#filters a");
      //$filters.removeClass('active');
      var _this = this;

      $filters.click(function (e) {
        e.preventDefault();
        $filters.removeClass("active");
        var a = $(e.currentTarget);
        var f = a.data("filterval");
        a.addClass("active");
        // _this.doIsotope(f);
      });
    }
    // this.initIsotope();
  },

  // Configure and setup all our isotope event grid functionality
  initIsotope: function () {
    // Run isotope on events grid
    this.doIsotope();
  },
  // Render the event grid as isotope masonry
  // optionally pass a filter function
  doIsotope: function (filter) {
    if ($("#iso-grid").length > 0) {
      var options = {
        layoutMode: "fitRows",
        itemSelector: ".item",
        percentPosition: true,
      };
      if (filter != undefined) {
        options.filter = filter;
      }
      $("#iso-grid").isotope(options);
    }
  },

  // Additional JS magic in Userforms
  initForms: function () {},

  // Contact Page, Locations Map, also Location detail page map
  initContactLocations: function () {
    var canvas = $("#location-map-canvas");
    var isSingle = canvas.hasClass("single"); // diff logic on single location pages.

    if (canvas.length > 0) {
      // Storage for markers as array. We need this to be able to remove markers when filtering.
      var markers = [];

      // Construct Map
      var mapOptions = {
        draggable: !("ontouchend" in document) || screen.width > 320,
        //draggable: true,
        scrollwheel: false,
        zoom: 12,
        maxZoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        mapTypeControl: false,
      };
      var map = new google.maps.Map(
        document.getElementById("location-map-canvas"),
        mapOptions
      );

      // Custom Styles on the Map
      //var styles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#4a6e68"}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"lightness":"12"},{"saturation":"-100"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#406d68"}]},{"featureType":"administrative.country","elementType":"geometry.fill","stylers":[{"weight":"5.83"}]},{"featureType":"administrative.province","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.locality","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"geometry.fill","stylers":[{"color":"#ff0000"},{"visibility":"on"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#888686"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"saturation":"-100"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#cae4e0"}]},{"featureType":"landscape","elementType":"labels.text","stylers":[{"color":"#406d68"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"saturation":"-19"},{"lightness":"43"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"saturation":"-100"},{"color":"#ced4d3"},{"lightness":"10"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.fill","stylers":[{"color":"#819895"}]},{"featureType":"landscape.natural.landcover","elementType":"geometry.stroke","stylers":[{"lightness":"-19"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"poi.business","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"poi.government","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"visibility":"on"},{"color":"#d3e6e2"}]},{"featureType":"poi.park","elementType":"geometry.stroke","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels","stylers":[{"visibility":"on"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#888686"}]},{"featureType":"poi.park","elementType":"labels.icon","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#fcfcfc"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.highway","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry.fill","stylers":[{"visibility":"on"}]},{"featureType":"transit.station.airport","elementType":"geometry.fill","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#adc7c4"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"visibility":"on"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"visibility":"on"}]}];
      map.setOptions({ styles: mapstyles });

      if (isSingle) {
        // Single Location Page
        var lat = $("#single-location").data("lat"); //'51.0486163';
        var lon = $("#single-location").data("lon"); //'-114.0708458';
        var loc = new google.maps.LatLng(lat, lon);
        var marker = new google.maps.Marker({
          position: loc,
          icon: "/wp-content/themes/challenger/assets/images/m1.png",
          map: map,
        });
        map.setCenter(loc);
      } else {
        // Locations Map
        var locations = $("#locations-grid").find("> .location");

        // Draw the markers for the first time.
        drawMarkers();

        // Drawing markers on the map
        function drawMarkers() {
          // Storage for the google bounds. We will fitBounds after markers are drawn.
          var bounds = new google.maps.LatLngBounds();

          // Draw store locations on the map
          locations.filter(":visible").each(function (i, el) {
            var loc = $(el);
            var marker = new google.maps.Marker({
              position: new google.maps.LatLng(
                loc.data("lat"),
                loc.data("lon")
              ),
              map: map,
              icon: "/wp-content/themes/challenger/assets/images/m1.png",
              //icon: '/wp-content/themes/challenger/assets/images/marker.png',
              info: infoWindowMarkup(loc.find(".txt")),
            });

            // Add to global storage array.
            markers.push(marker);

            google.maps.event.addListener(marker, "click", function () {
              try {
                infowindow.close();
              } catch (err) {}
              infowindow = new google.maps.InfoWindow({
                content: marker.info,
              });
              infowindow.open(map, marker);
            });

            // Extend the map bounds
            bounds.extend(marker.position);
          });
          map.fitBounds(bounds);
        }
        function infoWindowMarkup(loc) {
          $locationHtml =
            '<div class="location-popup">' + loc.html() + "</div>";
          return $locationHtml;
        }
      }
    }
  },

  smoothScroll: function () {
    $('.content-location-map > .container nav ul li a').on('click', function (e) {
        //alert('hello world');
      e.preventDefault()

      $('html, body').animate(
          {
            scrollTop: $($(this).attr('href')).offset().top + -120,
          },
          500,
          'linear'
      )
    });

  },

  locationDropdown: function () {
    $(".content-location-map > .container nav").on("click", ".select-text", function() {
      //alert('hello world');
      $(this).parent().toggleClass('open');
    });

    $(".content-location-map > .container nav ul li").click(function () {
      $(this).parent().parent('.content-location-map > .container nav').removeClass('open');
      $(this).parent().prev('.select-text').html($(this).html());
    });
  },

};

// Document Ready Handler - Kick it all off!
(function ($) {
  $(document).ready(function () {
    // Setup Our site on document ready
    site = MySite.init($);
  });
})(jQuery);

var mapstyles = [
  {
    featureType: "administrative.country",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "geometry",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#eace9e",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "geometry.fill",
    stylers: [
      {
        hue: "#ff0000",
      },
    ],
  },
  {
    featureType: "administrative.country",
    elementType: "labels",
    stylers: [
      {
        color: "#ad8f5a",
      },
    ],
  },
  {
    featureType: "administrative.province",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
      {
        color: "#b77510",
      },
    ],
  },
  {
    featureType: "administrative.locality",
    elementType: "all",
    stylers: [
      {
        visibility: "simplified",
      },
      {
        color: "#876118",
      },
    ],
  },
  {
    featureType: "administrative.neighborhood",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "administrative.land_parcel",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
      {
        weight: "4",
      },
      {
        hue: "#ffa900",
      },
    ],
  },
  {
    featureType: "landscape",
    elementType: "geometry",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "landscape.natural",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "landscape.natural.landcover",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "landscape.natural.landcover",
    elementType: "geometry",
    stylers: [
      {
        hue: "#ff9a00",
      },
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "landscape.natural.terrain",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.attraction",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.business",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.government",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.medical",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.park",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "poi.place_of_worship",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.school",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "poi.sports_complex",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "road.highway",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.highway.controlled_access",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.arterial",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "road.local",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
    ],
  },
  {
    featureType: "transit",
    elementType: "all",
    stylers: [
      {
        visibility: "off",
      },
    ],
  },
  {
    featureType: "water",
    elementType: "all",
    stylers: [
      {
        visibility: "on",
      },
      {
        color: "#86bcc4",
      },
    ],
  },
];
